  <template>
    <yams-template>
      <template #header>
        <div class="mr-5">
          <h4 class="text-primary font-weight-bold">CHAT</h4>
        </div>
      </template>
      <template #content>
        <ProgressBar v-if="isLoading === true" mode="indeterminate" style="height: 6px"></ProgressBar>
        <div class="container">
          <div class="row">
            <div class="col-md">
              <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
                Créer un nouveau ticket <i class="fa-solid fa-plus"></i>
              </button>
            </div>
            <div class="col-8" v-if="ticket_selected != null">
              <h4 class="text-primary font-weight-bold">Conversations</h4>
            </div>
          </div>
        </div>
      </template>
    </yams-template>
  </template>

<script>

import { defineComponent, defineAsyncComponent } from 'vue';
const CreateTicket = defineAsyncComponent(() => import('./CreateTicket.vue'));

export default defineComponent({
  name: 'IndexTicket',
  data() {
    return {
      lines: 0,
      isLoading: false,
      table: 'tickets',
      baseUrl: this.$store.state.api_yams_livraisons,
      key: 1,
      ticket_selected: null


    };
  },
  // mounted() {
  // },
  methods: {

    openCreateModal() {
      this.$dialog.open(CreateTicket, {
        props: {
          header: "Nouvelle conversation",
          style: {
            width: '40vw'
          },
          modal: true
        }
      });
    },

  }

});
</script>


<style scoped>
.chat-container {
  max-width: 600px;
  margin: auto;
  height: 80vh;
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
}

.message {
  margin-bottom: 10px;
}

.message.sent {
  text-align: right;
}

.message.received {
  text-align: left;
}

.message .content {
  display: inline-block;
  padding: 10px;
  border-radius: 10px;
}

.message.sent .content {
  background-color: #007bff;
  color: white;
}

.message.received .content {
  background-color: #f1f1f1;
  color: black;
}
</style> 